import React, { useState, Fragment, useEffect, useContext } from 'react';
import styles from './Subscription.module.css';
import {
    Button,
    Card,
    Checkbox,
    Col,
    Divider,
    Form,
    Input,
    Layout,
    List,
    Row,
    Select,
    Spin,
    Table,
    Typography,
} from 'antd';
import { SubscribeHead } from '..';
import { CiCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { Heads } from '..';
import { fetchJsData } from '../../api';
import { crawl } from '../../api/util';
import { UserContext } from '../Reducers/UserContext';
const { Text, Title } = Typography;
const CheckboxGroup = Checkbox.Group;

const cciList = [
    {
        subArea: 'New Apps',
    },
    {
        subArea: 'New Domains',
    },
    {
        subArea: 'CCL Changed Apps',
    },
    {
        subArea: 'Category Changed Apps',
    },
    {
        subArea: 'Name Changed Apps',
    },
    {
        subArea: 'Breached Apps',
    },
];

const conList = [
    {
        subArea: 'Modified Connectors',
    },
    {
        subArea: 'Traffic Changes',
    },
];

const topCatList = [
    {
        subArea: 'Top App Categories',
    },
];

const webCatList = [
    {
        subArea: 'Web Categories',
    },
];

export const CatSelectors = (props) => {
    const [value, setValue] = useState([...new Set(props.catList.map((x) => x.name))]);
    const [opt, setOpts] = useState(
        props.catList.map((x) => {
            return { id: x.id, label: x.name, value: x.name };
        })
    );
    const [options, setOptions] = useState(props.catOptions);

    const selectProps = {
        mode: 'multiple',
        style: {
            width: '100%',
        },
        value,
        options,
        // allowClear: true,
        onChange: (newValue) => {
            // console.log(newValue.length, value.length);
            if (newValue.length > value.length) {
                setValue(newValue);
                setOpts(newValue.map((x) => options.filter((i) => i.label == x)[0]));
                props.setBtn(false);
            }
        },
        placeholder: 'Subscribe to specific categories...',
        maxTagCount: 'responsive',
    };

    return (
        <>
            <Row>
                <Col xs={24} xl={24}>
                    <Card style={{ minheight: '200px', maxHeight: '280px', overflow: 'auto' }}>
                        <>
                            {/* head */}

                            <Row>
                                <Col span={1}></Col>
                                <Col span={18}>
                                    <Text ellipsis style={{ paddingBottom: '3px' }}>
                                        App Category Changes
                                    </Text>
                                </Col>
                            </Row>
                            <Row
                                style={{
                                    marginTop: '0px',
                                    paddingTop: '0px',
                                    marginBottom: '8px',
                                }}
                            >
                                <Col span={1}></Col>
                                <Col span={22}>
                                    <Select {...selectProps} />
                                </Col>
                            </Row>

                            {/* Options */}
                            <Row>
                                <Col span={11}></Col>
                                <Col span={7}>Release Changes</Col>
                                <Col span={6}>Weekly Changes</Col>
                            </Row>

                            {/* list */}
                            <div>
                                <Row>
                                    <Col span={1}></Col>

                                    <Col span={8}>
                                        {opt.map((i, ind) => (
                                            <>
                                                <Form.Item
                                                    // name={"release-" + ind}
                                                    key={ind}
                                                    style={{
                                                        marginBottom: '0px',
                                                    }}
                                                >
                                                    <Text ellipsis>{i.label}</Text>
                                                </Form.Item>

                                                {/* <br /> */}
                                            </>
                                        ))}
                                    </Col>
                                    <Col span={3}>
                                        <Divider
                                            style={{
                                                height: '90%',
                                                // marginTop: "10px",
                                            }}
                                            type="vertical"
                                        />
                                    </Col>

                                    <Col span={4}>
                                        <Form.Item
                                            name="cat-release-check-group"
                                            // label="Checkbox.Group"
                                        >
                                            <Checkbox.Group>
                                                <Row>
                                                    {opt.map((i, ind) => (
                                                        <>
                                                            <Col span={24}>
                                                                <Checkbox
                                                                    key={ind * 2}
                                                                    value={i.id}
                                                                    style={{
                                                                        lineHeight: '32px',
                                                                    }}
                                                                >
                                                                    {}
                                                                </Checkbox>
                                                            </Col>
                                                        </>
                                                    ))}
                                                </Row>
                                            </Checkbox.Group>
                                        </Form.Item>
                                    </Col>

                                    <Col span={3}>
                                        <Divider
                                            style={{
                                                height: '90%',
                                                // marginTop: "10px",
                                            }}
                                            type="vertical"
                                        />
                                    </Col>

                                    <Col span={3}>
                                        <Form.Item
                                            name="cat-weekly-check-group"
                                            // label="Checkbox.Group"
                                        >
                                            <Checkbox.Group>
                                                <Row>
                                                    {opt.map((i, ind) => (
                                                        <>
                                                            <Col span={24}>
                                                                <Checkbox
                                                                    key={ind * 3}
                                                                    value={i.id}
                                                                    style={{
                                                                        lineHeight: '32px',
                                                                    }}
                                                                >
                                                                    {}
                                                                </Checkbox>
                                                            </Col>
                                                        </>
                                                    ))}
                                                </Row>
                                            </Checkbox.Group>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export const AppSelectors = (props) => {
    const [value, setValue] = useState([...new Set(props.appList.map((x) => x.name))]);
    const [opt, setOpts] = useState(
        props.appList.map((x) => {
            return { id: x.id, label: x.name, value: x.name };
        })
    );
    const [options, setOptions] = useState(props.appOptions);

    const selectProps = {
        mode: 'multiple',
        style: {
            width: '100%',
        },
        value,
        options,
        // allowClear: true,
        onChange: (newValue) => {
            if (newValue.length > value.length) {
                setValue(newValue);
                setOpts(newValue.map((x) => options.filter((i) => i.label == x)[0]));
                props.setBtn(false);
            }
            // if (newValue.length > value.length) {
            //   let addVal = options.filter(
            //     (x) => x.label == newValue.filter((x) => value.indexOf(x) == -1)
            //   );

            //   console.log(
            //     newValue.map((x) => options.filter((i) => i.label == x)[0]).length
            //   );
            //   console.log(newValue);
            //   setValue(newValue);
            //   // setOpts(newValue.map((x) => options.filter((i) => i.label == x)[0]));
            //   addVal.length > 0
            //     ? setOpts([...opt, addVal[0]])
            //     : setOpts(
            //         newValue.map((x) => options.filter((i) => i.label == x)[0])
            //       );
            //   props.setBtn(false);
            //   console.log(opt);
            // }
        },
        placeholder: 'Subscribe to specific applications...',
        maxTagCount: 'responsive',
    };

    return (
        <>
            <Row>
                <Col xs={24} xl={24}>
                    <Card style={{ minheight: '200px', maxHeight: '310px', overflow: 'auto' }}>
                        <>
                            {/* head */}

                            <Row>
                                <Col span={1}></Col>
                                <Col span={10}>
                                    <Text ellipsis style={{ paddingBottom: '3px' }}>
                                        Application Changes
                                    </Text>
                                </Col>
                            </Row>
                            <Row
                                style={{
                                    marginTop: '0px',
                                    paddingTop: '0px',
                                    marginBottom: '8px',
                                }}
                            >
                                <Col span={1}></Col>
                                <Col span={22}>
                                    <Select {...selectProps} />
                                </Col>
                            </Row>

                            {/* Options */}
                            <Row>
                                <Col span={11}></Col>
                                <Col span={7}>Release Changes</Col>
                                <Col span={6}>Weekly Changes</Col>
                            </Row>

                            {/* list */}
                            <div>
                                <Row>
                                    <Col span={1}></Col>

                                    <Col span={8}>
                                        {opt.map((i, ind) => (
                                            <>
                                                <Form.Item
                                                    // name={"release-" + ind}
                                                    key={ind}
                                                    style={{ marginBottom: '0px' }}
                                                >
                                                    <Text ellipsis>{i.label}</Text>
                                                </Form.Item>

                                                {/* <br /> */}
                                            </>
                                        ))}
                                    </Col>
                                    <Col span={3}>
                                        <Divider
                                            style={{
                                                height: '90%',
                                                // marginTop: "10px",
                                            }}
                                            type="vertical"
                                        />
                                    </Col>

                                    <Col span={4}>
                                        <Form.Item
                                            name="app-release-check-group"
                                            // label="Checkbox.Group"
                                        >
                                            <Checkbox.Group>
                                                <Row>
                                                    {opt.map((i, ind) => (
                                                        <>
                                                            <Col span={24}>
                                                                <Checkbox
                                                                    key={ind * 2}
                                                                    value={i.id}
                                                                    style={{
                                                                        lineHeight: '32px',
                                                                    }}
                                                                >
                                                                    {}
                                                                </Checkbox>
                                                            </Col>
                                                        </>
                                                    ))}
                                                </Row>
                                            </Checkbox.Group>
                                        </Form.Item>
                                    </Col>

                                    <Col span={3}>
                                        <Divider
                                            style={{
                                                height: '90%',
                                                // marginTop: "10px",
                                            }}
                                            type="vertical"
                                        />
                                    </Col>

                                    <Col span={3}>
                                        <Form.Item
                                            name="app-weekly-check-group"
                                            // label="Checkbox.Group"
                                        >
                                            <Checkbox.Group>
                                                <Row>
                                                    {opt.map((i, ind) => (
                                                        <>
                                                            <Col span={24}>
                                                                <Checkbox
                                                                    key={ind * 3}
                                                                    value={i.id}
                                                                    style={{
                                                                        lineHeight: '32px',
                                                                    }}
                                                                >
                                                                    {}
                                                                </Checkbox>
                                                            </Col>
                                                        </>
                                                    ))}
                                                </Row>
                                            </Checkbox.Group>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </>
                    </Card>
                </Col>
            </Row>

            {/* connector */}
            <br />
        </>
    );
};

export const CciCard = (props) => {
    return (
        <>
            <Row>
                <Col xs={24} xl={24}>
                    <Card
                        bodyStyle={{
                            paddingBottom: '0',
                            paddingTop: '3px',
                        }}
                    >
                        <>
                            {/* head */}
                            <Row>
                                <Col span={1}></Col>
                                <Col span={10}>
                                    <Text>
                                        <CiCircleOutlined /> CCI Changes
                                    </Text>
                                </Col>
                            </Row>

                            {/* Options */}
                            <Row>
                                <Col span={12}></Col>
                                <Col span={6}>Release Changes</Col>
                                <Col span={6}>Weekly Changes</Col>
                            </Row>

                            {/* list */}
                            <Row>
                                <Col span={1}></Col>

                                <Col span={10}>
                                    {cciList.map((i, ind) => (
                                        <>
                                            <Form.Item
                                                // name={"release-" + ind}
                                                style={{ marginBottom: '0px' }}
                                            >
                                                <Text ellipsis>{i.subArea}</Text>
                                            </Form.Item>

                                            {/* <br /> */}
                                        </>
                                    ))}
                                </Col>
                                <Col span={3}>
                                    <Divider
                                        style={{
                                            height: '90%',
                                            // marginTop: "10px",
                                        }}
                                        type="vertical"
                                    />
                                </Col>

                                <Col span={3}>
                                    <Form.Item
                                        name="cci-release-check-group"
                                        // label="Checkbox.Group"
                                    >
                                        <Checkbox.Group>
                                            <Row>
                                                {cciList.map((i, ind) => (
                                                    <>
                                                        <Col span={24}>
                                                            <Checkbox
                                                                value={ind + ind + 1}
                                                                style={{
                                                                    lineHeight: '32px',
                                                                }}
                                                            >
                                                                {}
                                                            </Checkbox>
                                                        </Col>
                                                    </>
                                                ))}
                                            </Row>
                                        </Checkbox.Group>
                                    </Form.Item>
                                </Col>

                                <Col span={3}>
                                    <Divider
                                        style={{
                                            height: '90%',
                                            // marginTop: "10px",
                                        }}
                                        type="vertical"
                                    />
                                </Col>

                                <Col span={3}>
                                    <Form.Item
                                        name="cci-weekly-check-group"
                                        // label="Checkbox.Group"
                                    >
                                        <Checkbox.Group>
                                            <Row>
                                                {cciList.map((i, ind) => (
                                                    <>
                                                        <Col span={24}>
                                                            <Checkbox
                                                                value={(ind + 1) * 2}
                                                                style={{
                                                                    lineHeight: '32px',
                                                                }}
                                                            >
                                                                {}
                                                            </Checkbox>
                                                        </Col>
                                                    </>
                                                ))}
                                            </Row>
                                        </Checkbox.Group>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    </Card>
                </Col>
            </Row>

            {/* connector */}
            <br />
            <Row>
                <Col xs={24} xl={24}>
                    <Card
                        bodyStyle={{
                            paddingBottom: '0',
                            paddingTop: '3px',
                        }}
                    >
                        <>
                            {/* head */}
                            <Row>
                                <Col span={1}></Col>
                                <Col span={10}>
                                    <Text>
                                        <CiCircleOutlined /> Connector Changes
                                    </Text>
                                </Col>
                            </Row>

                            {/* Options */}
                            <Row>
                                <Col span={11}></Col>
                                <Col span={7}>Release Changes</Col>
                                <Col span={6}>Weekly Changes</Col>
                            </Row>

                            {/* list */}
                            <Row>
                                <Col span={1}></Col>
                                {/* connector headings */}
                                <Col span={8}>
                                    {conList.map((i, ind) => (
                                        <>
                                            <Form.Item
                                                // name={"release-" + ind}
                                                style={{ marginBottom: '0px' }}
                                            >
                                                <Text ellipsis>{i.subArea}</Text>
                                            </Form.Item>

                                            {/* <br /> */}
                                        </>
                                    ))}
                                </Col>
                                <Col span={3}>
                                    <Divider
                                        style={{
                                            height: '90%',
                                            // marginTop: "10px",
                                        }}
                                        type="vertical"
                                    />
                                </Col>

                                <Col span={4}>
                                    <Form.Item
                                        name="con-release-check-group"
                                        // label="Checkbox.Group"
                                    >
                                        <Checkbox.Group>
                                            <Row>
                                                {conList.map((i, ind) => {
                                                    console.log('i', ind + ind + 1 + 22, ind);
                                                    return (
                                                        <>
                                                            <Col span={24}>
                                                                {ind !== 1 ? (
                                                                    <Checkbox
                                                                        value={ind + ind + 1 + 22}
                                                                        style={{
                                                                            lineHeight: '32px',
                                                                        }}
                                                                    >
                                                                        {}
                                                                    </Checkbox>
                                                                ) : (
                                                                    <Text
                                                                        style={{
                                                                            lineHeight: '32px',
                                                                        }}
                                                                        disabled
                                                                    >
                                                                        NA
                                                                    </Text>
                                                                )}
                                                            </Col>
                                                        </>
                                                    );
                                                })}
                                            </Row>
                                        </Checkbox.Group>
                                    </Form.Item>
                                </Col>

                                <Col span={3}>
                                    <Divider
                                        style={{
                                            height: '90%',
                                            // marginTop: "10px",
                                        }}
                                        type="vertical"
                                    />
                                </Col>

                                <Col span={3}>
                                    <Form.Item
                                        name="con-weekly-check-group"
                                        // label="Checkbox.Group"
                                    >
                                        <Checkbox.Group>
                                            <Row>
                                                {conList.map((i, ind) => {
                                                    console.log('ind - ', (ind + 4) * 2 + 14, ind);
                                                    return (
                                                        <>
                                                            <Col span={24}>
                                                                {/* {ind !== 3 ? (
                                                                    <Text
                                                                        style={{
                                                                            lineHeight: '32px',
                                                                        }}
                                                                        disabled
                                                                    >
                                                                        NA
                                                                    </Text>
                                                                ) : ( */}
                                                                <Checkbox
                                                                    value={(ind + 4) * 2 + 14}
                                                                    style={{
                                                                        lineHeight: '32px',
                                                                    }}
                                                                >
                                                                    {}
                                                                </Checkbox>
                                                                {/* )} */}
                                                            </Col>
                                                        </>
                                                    );
                                                })}
                                            </Row>
                                        </Checkbox.Group>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    </Card>
                </Col>
            </Row>

            {/* Top App Category Changes */}
            <br />
            <Row>
                <Col xs={24} xl={24}>
                    <Card
                        bodyStyle={{
                            paddingBottom: '0',
                            paddingTop: '3px',
                        }}
                    >
                        <>
                            {/* head */}
                            <Row>
                                <Col span={1}></Col>
                                <Col span={10}>
                                    <Tooltip
                                        title="Subset of 'All App Categories', accounts for 90% of App traffic across Netskope customer base"
                                        overlayStyle={{
                                            maxWidth: '300px',
                                            fontSize: '12px',
                                        }}
                                    >
                                        <Text>
                                            <CiCircleOutlined /> Top App Category Changes
                                        </Text>
                                    </Tooltip>
                                </Col>
                            </Row>

                            {/* Options */}
                            <Row>
                                <Col span={11}></Col>
                                <Col span={7}>Release Changes</Col>
                                <Col span={6}>Weekly Changes</Col>
                            </Row>

                            {/* list */}
                            <Row>
                                <Col span={1}></Col>

                                <Col span={8}>
                                    {topCatList.map((i, ind) => (
                                        <>
                                            <Form.Item
                                                // name={"release-" + ind}
                                                style={{ marginBottom: '0px' }}
                                            >
                                                <Text ellipsis>{i.subArea}</Text>
                                            </Form.Item>

                                            {/* <br /> */}
                                        </>
                                    ))}
                                </Col>
                                <Col span={3}>
                                    <Divider
                                        style={{
                                            height: '90%',
                                            // marginTop: "10px",
                                        }}
                                        type="vertical"
                                    />
                                </Col>

                                <Col span={4}>
                                    <Form.Item
                                        name="topcat-release-check-group"
                                        // label="Checkbox.Group"
                                    >
                                        <Checkbox.Group>
                                            <Row>
                                                {topCatList.map((i, ind) => (
                                                    <>
                                                        <Col span={24}>
                                                            <Checkbox
                                                                value={ind + ind + 1 + 18}
                                                                style={{
                                                                    lineHeight: '32px',
                                                                }}
                                                            >
                                                                {}
                                                            </Checkbox>
                                                        </Col>
                                                    </>
                                                ))}
                                            </Row>
                                        </Checkbox.Group>
                                    </Form.Item>
                                </Col>

                                <Col span={3}>
                                    <Divider
                                        style={{
                                            height: '90%',
                                            // marginTop: "10px",
                                        }}
                                        type="vertical"
                                    />
                                </Col>

                                <Col span={3}>
                                    <Form.Item
                                        name="topcat-weekly-check-group"
                                        // label="Checkbox.Group"
                                    >
                                        <Checkbox.Group>
                                            <Row>
                                                {topCatList.map((i, ind) => (
                                                    <>
                                                        <Col span={24}>
                                                            <Checkbox
                                                                value={(ind + 1) * 2 + 18}
                                                                style={{
                                                                    lineHeight: '32px',
                                                                }}
                                                            >
                                                                {}
                                                            </Checkbox>
                                                        </Col>
                                                    </>
                                                ))}
                                            </Row>
                                        </Checkbox.Group>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    </Card>
                </Col>
            </Row>

            {/* Web Category Changes */}
            <br />
            <Row>
                <Col xs={24} xl={24}>
                    <Card
                        bodyStyle={{
                            paddingBottom: '0',
                            paddingTop: '3px',
                        }}
                    >
                        <>
                            {/* head */}
                            <Row>
                                <Col span={1}></Col>
                                <Col span={10}>
                                    <Tooltip
                                        title="Web Category Changes"
                                        overlayStyle={{
                                            maxWidth: '300px',
                                            fontSize: '12px',
                                        }}
                                    >
                                        <Text>
                                            <CiCircleOutlined /> Web Category Changes
                                        </Text>
                                    </Tooltip>
                                </Col>
                            </Row>

                            {/* Options */}
                            <Row>
                                <Col span={11}></Col>
                                <Col span={7}>Release Changes</Col>
                                <Col span={6}>Weekly Changes</Col>
                            </Row>

                            {/* list */}
                            <Row>
                                <Col span={1}></Col>

                                <Col span={8}>
                                    {webCatList.map((i, ind) => (
                                        <>
                                            <Form.Item
                                                // name={"release-" + ind}
                                                style={{ marginBottom: '0px' }}
                                            >
                                                <Text ellipsis>{i.subArea}</Text>
                                            </Form.Item>

                                            {/* <br /> */}
                                        </>
                                    ))}
                                </Col>
                                <Col span={3}>
                                    <Divider
                                        style={{
                                            height: '90%',
                                            // marginTop: "10px",
                                        }}
                                        type="vertical"
                                    />
                                </Col>

                                <Col span={4}>
                                    <Text disabled>NA</Text>
                                </Col>

                                <Col span={3}>
                                    <Divider
                                        style={{
                                            height: '90%',
                                            // marginTop: "10px",
                                        }}
                                        type="vertical"
                                    />
                                </Col>

                                <Col span={3}>
                                    <Form.Item
                                        name="webcat-weekly-check-group"
                                        // label="Checkbox.Group"
                                    >
                                        <Checkbox.Group>
                                            <Row>
                                                {webCatList.map((i, ind) => (
                                                    <>
                                                        <Col span={24}>
                                                            <Checkbox
                                                                value={(ind + 1) * 2 + 19}
                                                                style={{
                                                                    lineHeight: '32px',
                                                                }}
                                                            >
                                                                {}
                                                            </Checkbox>
                                                        </Col>
                                                    </>
                                                ))}
                                            </Row>
                                        </Checkbox.Group>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    </Card>
                </Col>
            </Row>
        </>
    );
};
